import { useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useModuleConfigForm } from '../../../../../utils/hooks/useModuleConfigForm';
import { FormValues } from './types';
import { configAdapter, submitAdapter } from './adapters';
import { validationSchema } from './validation';
import {
  inviteModuleSaved,
  inviteModuleInitialized,
} from '../../../../actions/modules';

export const useForm = ({ moduleId }) => {
  const dispatch = useDispatch();
  const onSubmitSuccess = useCallback(
    () => dispatch(inviteModuleSaved()),
    [dispatch]
  );
  const onConfigFetchSuccess = useCallback(
    () => dispatch(inviteModuleInitialized()),
    [dispatch]
  );
  const { isInitialized, requestSubmit, formContext } =
    useModuleConfigForm<FormValues>(moduleId, {
      validationSchema,
      configAdapter,
      submitAdapter,
      subpath: '/invite',
      onSubmitSuccess,
      onConfigFetchSuccess,
    });

  const { register } = formContext;
  useEffect(() => {
    register('options');
  }, [register]);

  return { isInitialized, requestSubmit, formContext };
};
